import { type TFunction } from 'react-i18next';

import { type GroupInvite } from '@app/client/common/structs/groups/groups';
import { type GroupMember } from '@app/gen';

type memberCountsType = {
    members?: GroupMember[];
    pendingGroupInvites?: GroupInvite[];
    isOwner?: boolean;
    followers?: GroupMember[];
    translateFn: TFunction<('common' | 'groups')[], undefined>;
};
// TODO: We should not pass `i18n > translate` function as an argument to a
// normal function. This should be converted to a React hook.
export function renderMemberCounts({
    members,
    pendingGroupInvites,
    isOwner,
    translateFn,
    followers,
}: memberCountsType) {
    if (followers) {
        return followers?.length > 1
            ? translateFn('groups:pods_members_title_followers', { count: followers.length })
            : translateFn('groups:pods_members_title_follower');
    }

    let memberCountsString =
        members?.length || 0 > 1
            ? translateFn('groups:pods_members_title_members', { count: members?.length })
            : translateFn('groups:pods_members_title_member');

    if (isOwner && (pendingGroupInvites?.length || 0) > 0) {
        const inviteCountsString =
            pendingGroupInvites?.length || 0 > 1
                ? translateFn('groups:pods_members_title_invites', { count: pendingGroupInvites?.length || 0 })
                : translateFn('groups:pods_members_title_invite');

        memberCountsString += `, ${inviteCountsString}`;
    }

    return memberCountsString;
}
